window.addEventListener('load', function () {
	document.querySelectorAll('.js-select').forEach(function (wrapper) {
		const select = wrapper.querySelector('select');
		if (!select) return;

		const firstOption = select.querySelector('option:first-child');
		if (firstOption) firstOption.remove();

		const defOption = document.createElement('option');
		defOption.value = 'Country';
		defOption.setAttribute('data-provinces', '[]');
		defOption.selected = true;
		defOption.disabled = true;
		select.prepend(defOption);

		const ph = document.createElement('div');
		ph.className = 'placeholder-select';
		ph.innerHTML = 'Country <span>*</span>';
		wrapper.prepend(ph);

		select.addEventListener('change', function () {
			this.style.color = 'rgb(var(--color-foreground), 1)';
			const placeholder = wrapper.querySelector('.placeholder-select');
			if (placeholder) placeholder.remove();
		});
	});
});